export default "__VITE_ASSET__D26st47D__"